import jump from 'jump.js';

export const hash = () => {
  let hash = window.location.hash;
  const hashEl = hash ? document.querySelector(window.location.hash) : null;

  if (hash && hashEl.tagName.toLowerCase() === 'wp-accordion-heading') {
    hash = hash.replace('#', '');
    window.location.hash = '';

    window.scrollTo(0, 0);
    window.addEventListener('load', () => {
      jump(hashEl, {
        duration: 750,
        offset: -66,
        a11y: true,
      });
    });
  }
};
